/* DEWA Learner Library curriculum navigation */
(function () {
    const root = document.querySelector('[data-dewa-libnav-root]');

    if (!root) {
        return;
    }

    try {
        const html = document.documentElement;
        const panel = root.querySelector('[data-dewa-libnav-panel]');
        const toggle = root.querySelector('[data-dewa-libnav-toggle]');
        const closeButton = root.querySelector('[data-dewa-libnav-close]');
        const closeLabel = root.querySelector('[data-dewa-libnav-close-label]');
        const backdrop = root.querySelector('[data-dewa-libnav-backdrop]');
        const resizer = root.querySelector('[data-dewa-libnav-resizer]');
        const pillarButtons = Array.from(root.querySelectorAll('[data-dewa-libnav-pillar-toggle]'));
        const navigation = document.querySelector('#gh-navigation');
        const desktopQuery = window.matchMedia('(min-width: 1200px)');
        const collapsedStorageKey = 'dewa.libraryNav.desktopCollapsed.v1';
        const widthStorageKey = 'dewa.libraryNav.desktopWidth.v1';
        const pillarStorageKey = 'dewa.libraryNav.pillars.v1';
        const scrollStorageKey = 'dewa.libraryNav.scrollTop.v1';
        const defaultDesktopWidth = 336;
        const minimumDesktopWidth = 288;
        const maximumDesktopWidth = 520;
        let drawerOpen = false;
        let returnFocus = null;
        let scrollFrame = null;
        let resizeStartX = 0;
        let resizeStartWidth = defaultDesktopWidth;
        let resizing = false;
        let restoringPillars = false;

        if (!panel || !toggle || !closeButton || !backdrop) {
            return;
        }

        function normalisePath(value) {
            try {
                const path = new URL(value, window.location.origin).pathname;
                return path.replace(/\/+$/, '') || '/';
            } catch (error) {
                return '';
            }
        }

        function readStorage(storage, key) {
            try {
                return storage.getItem(key);
            } catch (error) {
                return null;
            }
        }

        function writeStorage(storage, key, value) {
            try {
                storage.setItem(key, value);
            } catch (error) {
                // Storage may be unavailable; the in-page state still works.
            }
        }

        function readStoredObject(key) {
            const stored = readStorage(window.localStorage, key);

            if (!stored) {
                return {};
            }

            try {
                const parsed = JSON.parse(stored);
                return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
            } catch (error) {
                return {};
            }
        }

        function markCurrentItem() {
            if (root.querySelector('[aria-current="page"]')) {
                return;
            }

            const currentPath = normalisePath(window.location.href);
            const links = root.querySelectorAll('.dewa-libnav__link');

            links.forEach(function (link) {
                if (normalisePath(link.href) === currentPath) {
                    link.setAttribute('aria-current', 'page');
                }
            });
        }

        function parsePath(item) {
            const path = item.getAttribute('data-dewa-path') || '';

            if (/\bstart here\b/i.test(path)) {
                return {kind: 'start', rank: 0};
            }

            const match = path.match(/-\s*step\s+(\d+)\b/i);

            if (!match) {
                return null;
            }

            return {kind: 'step', rank: Number.parseInt(match[1], 10)};
        }

        function sortList(list) {
            const items = Array.from(list.querySelectorAll(':scope > .dewa-libnav__item'));
            const ranked = items
                .map(function (item, index) {
                    return {item: item, index: index, path: parsePath(item)};
                })
                .filter(function (entry) {
                    return entry.path && Number.isFinite(entry.path.rank);
                });
            const uniqueRanks = new Set(ranked.map(function (entry) {
                return entry.path.rank;
            }));

            if (ranked.length < 2 || uniqueRanks.size !== ranked.length) {
                return;
            }

            items
                .map(function (item, index) {
                    return {item: item, index: index, path: parsePath(item)};
                })
                .sort(function (left, right) {
                    if (left.path && right.path) {
                        return left.path.rank - right.path.rank;
                    }

                    if (left.path) {
                        return -1;
                    }

                    if (right.path) {
                        return 1;
                    }

                    return left.index - right.index;
                })
                .forEach(function (entry) {
                    list.appendChild(entry.item);
                });
        }

        function enhancePathStrip() {
            const pathRoot = document.querySelector('[data-dewa-library-path]');
            const currentLink = root.querySelector('.dewa-libnav__link[aria-current="page"]');

            if (!pathRoot || !currentLink) {
                return;
            }

            const currentItem = currentLink.closest('.dewa-libnav__item');
            const list = currentItem && currentItem.closest('[data-dewa-libnav-list]');
            const pillar = currentItem && currentItem.closest('[data-dewa-pillar]');
            const items = list ? Array.from(list.querySelectorAll(':scope > .dewa-libnav__item')) : [];

            if (!currentItem || !list || !pillar) {
                return;
            }

            const parsedCurrent = parsePath(currentItem);

            if (items.length < 2) {
                if (parsedCurrent) {
                    pathRoot.hidden = true;
                }

                return;
            }

            const position = pathRoot.querySelector('[data-dewa-library-position]');
            const previous = pathRoot.querySelector('[data-dewa-library-previous]');
            const next = pathRoot.querySelector('[data-dewa-library-next]');
            const enhanced = pathRoot.querySelector('[data-dewa-library-path-enhanced]');
            const fallback = pathRoot.querySelector('[data-dewa-library-path-fallback]');
            const heading = pillar.querySelector('h3');
            const currentIndex = items.indexOf(currentItem);
            const stepEntries = items.map(parsePath).filter(function (path) {
                return path && path.kind === 'step';
            });
            const stepRanks = stepEntries.map(function (path) {
                return path.rank;
            });
            const uniqueStepRanks = new Set(stepRanks);
            const stepsAreComplete = stepRanks.length > 0
                && uniqueStepRanks.size === stepRanks.length
                && Math.min.apply(null, stepRanks) === 1
                && Math.max.apply(null, stepRanks) === stepRanks.length;

            if (!parsedCurrent || !position || !previous || !next || !enhanced || !fallback || !heading) {
                return;
            }

            if (parsedCurrent.kind === 'start') {
                position.textContent = 'Start here in ' + heading.textContent.trim();
            } else if (stepsAreComplete) {
                position.textContent = 'Step ' + parsedCurrent.rank + ' of ' + stepEntries.length + ' in ' + heading.textContent.trim();
            } else {
                return;
            }

            function setAdjacentLink(link, item, label) {
                const itemLink = item && item.querySelector('.dewa-libnav__link');

                if (!itemLink) {
                    link.hidden = true;
                    link.removeAttribute('href');
                    return;
                }

                link.hidden = false;
                link.href = itemLink.href;
                link.textContent = label + ': ' + itemLink.querySelector('.dewa-libnav__title').textContent.trim();
            }

            setAdjacentLink(previous, items[currentIndex - 1], 'Previous');
            setAdjacentLink(next, items[currentIndex + 1], 'Next');
            fallback.hidden = true;
            enhanced.hidden = false;
        }

        function pillarKey(button) {
            const pillar = button.closest('[data-dewa-pillar]');
            return pillar ? pillar.getAttribute('data-dewa-pillar') : '';
        }

        function setPillarCollapsed(button, collapsed) {
            const pillar = button.closest('[data-dewa-pillar]');

            if (!pillar) {
                return;
            }

            pillar.open = !collapsed;
            button.setAttribute('aria-expanded', String(!collapsed));
            pillar.classList.toggle('is-collapsed', collapsed);
        }

        function restorePillarState() {
            const stored = readStoredObject(pillarStorageKey);
            restoringPillars = true;

            pillarButtons.forEach(function (button) {
                const pillar = button.closest('[data-dewa-pillar]');
                const key = pillarKey(button);
                const containsCurrentItem = Boolean(pillar && pillar.querySelector('[aria-current="page"]'));
                const collapsed = !containsCurrentItem && stored[key] === true;
                setPillarCollapsed(button, collapsed);
            });

            window.setTimeout(function () {
                restoringPillars = false;
            }, 0);
        }

        function persistPillarState() {
            const state = {};

            pillarButtons.forEach(function (button) {
                const key = pillarKey(button);
                const pillar = button.closest('[data-dewa-pillar]');
                if (key) {
                    state[key] = Boolean(pillar && !pillar.open);
                }
            });

            writeStorage(window.localStorage, pillarStorageKey, JSON.stringify(state));
        }

        function savePanelScrollPosition() {
            writeStorage(window.sessionStorage, scrollStorageKey, String(Math.max(0, Math.round(panel.scrollTop))));
        }

        function restorePanelScrollPosition() {
            const stored = Number.parseInt(readStorage(window.sessionStorage, scrollStorageKey), 10);
            const currentLink = root.querySelector('.dewa-libnav__link[aria-current="page"]');

            window.setTimeout(function () {
                if (Number.isFinite(stored) && stored >= 0) {
                    panel.scrollTop = Math.min(stored, Math.max(0, panel.scrollHeight - panel.clientHeight));
                } else if (currentLink) {
                    const targetTop = currentLink.offsetTop - Math.max(24, (panel.clientHeight - currentLink.offsetHeight) / 2);
                    panel.scrollTop = Math.max(0, targetTop);
                }
            }, 0);
        }

        function updateControlLabels() {
            const closeText = desktopQuery.matches ? 'Collapse' : 'Close';
            closeButton.setAttribute('aria-label', closeText + ' Library path');

            if (closeLabel) {
                closeLabel.textContent = closeText;
            }
        }

        function setPanelState() {
            const desktopExpanded = desktopQuery.matches && !html.classList.contains('dewa-libnav-collapsed');
            const expanded = desktopQuery.matches ? desktopExpanded : drawerOpen;

            toggle.setAttribute('aria-expanded', String(expanded));

            if (expanded) {
                panel.removeAttribute('aria-hidden');
            } else {
                panel.setAttribute('aria-hidden', 'true');
            }

            if (!desktopQuery.matches && drawerOpen) {
                panel.setAttribute('role', 'dialog');
                panel.setAttribute('aria-modal', 'true');
            } else {
                panel.removeAttribute('role');
                panel.removeAttribute('aria-modal');
            }

            updateControlLabels();
        }

        function openDrawer() {
            if (desktopQuery.matches || drawerOpen) {
                return;
            }

            returnFocus = document.activeElement;
            drawerOpen = true;
            root.classList.add('is-open');
            html.classList.add('dewa-libnav-locked');
            setPanelState();
            closeButton.focus();
        }

        function closeDrawer(restoreFocus) {
            if (!drawerOpen) {
                setPanelState();
                return;
            }

            drawerOpen = false;
            root.classList.remove('is-open');
            html.classList.remove('dewa-libnav-locked');
            setPanelState();

            if (restoreFocus && returnFocus && typeof returnFocus.focus === 'function') {
                returnFocus.focus();
            }

            returnFocus = null;
        }

        function setDesktopCollapsed(collapsed) {
            if (collapsed) {
                savePanelScrollPosition();
            }

            html.classList.toggle('dewa-libnav-collapsed', collapsed);
            writeStorage(window.localStorage, collapsedStorageKey, String(collapsed));
            setPanelState();
        }

        function desktopWidthBounds() {
            const viewportSafeMaximum = Math.max(minimumDesktopWidth, window.innerWidth - 840);
            return {
                min: minimumDesktopWidth,
                max: Math.min(maximumDesktopWidth, viewportSafeMaximum),
            };
        }

        function currentDesktopWidth() {
            const value = Number.parseFloat(getComputedStyle(html).getPropertyValue('--dewa-libnav-width'));
            return Number.isFinite(value) ? value : defaultDesktopWidth;
        }

        function setDesktopWidth(value, persist) {
            const bounds = desktopWidthBounds();
            const width = Math.round(Math.min(bounds.max, Math.max(bounds.min, value)));

            html.style.setProperty('--dewa-libnav-width', width + 'px');

            if (resizer) {
                resizer.setAttribute('aria-valuemin', String(bounds.min));
                resizer.setAttribute('aria-valuemax', String(bounds.max));
                resizer.setAttribute('aria-valuenow', String(width));
            }

            if (persist) {
                writeStorage(window.localStorage, widthStorageKey, String(width));
            }

            return width;
        }

        function restoreDesktopWidth() {
            const stored = Number.parseInt(readStorage(window.localStorage, widthStorageKey), 10);
            setDesktopWidth(Number.isFinite(stored) ? stored : currentDesktopWidth(), false);
        }

        function endResize(event) {
            if (!resizing) {
                return;
            }

            resizing = false;
            html.classList.remove('dewa-libnav-is-resizing');

            if (resizer && event && typeof event.pointerId === 'number' && resizer.hasPointerCapture(event.pointerId)) {
                resizer.releasePointerCapture(event.pointerId);
            }

            setDesktopWidth(currentDesktopWidth(), true);
        }

        function updateHeaderOffset() {
            const header = navigation || document.querySelector('.gh-navigation');
            const height = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
            html.style.setProperty('--dewa-libnav-top', Math.max(height + 16, 78) + 'px');
        }

        function focusableElements() {
            return Array.from(panel.querySelectorAll(
                'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
            )).filter(function (element) {
                return element.offsetParent !== null;
            });
        }

        root.querySelectorAll('[data-dewa-libnav-list]').forEach(sortList);
        markCurrentItem();
        restorePillarState();
        enhancePathStrip();
        restoreDesktopWidth();
        restorePanelScrollPosition();

        pillarButtons.forEach(function (button) {
            const pillar = button.closest('[data-dewa-pillar]');

            if (!pillar) {
                return;
            }

            pillar.addEventListener('toggle', function () {
                const collapsed = !pillar.open;
                button.setAttribute('aria-expanded', String(!collapsed));
                pillar.classList.toggle('is-collapsed', collapsed);

                if (!restoringPillars) {
                    persistPillarState();
                    savePanelScrollPosition();
                }
            });
        });

        panel.addEventListener('scroll', function () {
            if (scrollFrame) {
                return;
            }

            scrollFrame = window.requestAnimationFrame(function () {
                savePanelScrollPosition();
                scrollFrame = null;
            });
        }, {passive: true});

        root.querySelectorAll('.dewa-libnav__link').forEach(function (link) {
            link.addEventListener('click', savePanelScrollPosition);
        });

        window.addEventListener('pagehide', savePanelScrollPosition);

        toggle.addEventListener('click', function () {
            if (desktopQuery.matches) {
                setDesktopCollapsed(false);
                window.setTimeout(function () {
                    closeButton.focus();
                }, 0);
            } else {
                openDrawer();
            }
        });

        closeButton.addEventListener('click', function () {
            if (desktopQuery.matches) {
                setDesktopCollapsed(true);
                window.setTimeout(function () {
                    toggle.focus();
                }, 0);
            } else {
                closeDrawer(true);
            }
        });

        backdrop.addEventListener('click', function () {
            closeDrawer(true);
        });

        if (resizer) {
            resizer.addEventListener('pointerdown', function (event) {
                if (!desktopQuery.matches || html.classList.contains('dewa-libnav-collapsed')) {
                    return;
                }

                event.preventDefault();
                resizing = true;
                resizeStartX = event.clientX;
                resizeStartWidth = currentDesktopWidth();
                resizer.setPointerCapture(event.pointerId);
                html.classList.add('dewa-libnav-is-resizing');
            });

            resizer.addEventListener('pointermove', function (event) {
                if (!resizing) {
                    return;
                }

                setDesktopWidth(resizeStartWidth + event.clientX - resizeStartX, false);
            });

            resizer.addEventListener('pointerup', endResize);
            resizer.addEventListener('pointercancel', endResize);

            resizer.addEventListener('dblclick', function () {
                setDesktopWidth(defaultDesktopWidth, true);
            });

            resizer.addEventListener('keydown', function (event) {
                const bounds = desktopWidthBounds();
                const step = event.shiftKey ? 32 : 16;
                let width = currentDesktopWidth();

                if (event.key === 'ArrowLeft') {
                    width -= step;
                } else if (event.key === 'ArrowRight') {
                    width += step;
                } else if (event.key === 'Home') {
                    width = bounds.min;
                } else if (event.key === 'End') {
                    width = bounds.max;
                } else {
                    return;
                }

                event.preventDefault();
                setDesktopWidth(width, true);
            });
        }

        document.addEventListener('keydown', function (event) {
            if (!drawerOpen) {
                return;
            }

            if (event.key === 'Escape') {
                event.preventDefault();
                closeDrawer(true);
                return;
            }

            if (event.key !== 'Tab') {
                return;
            }

            const focusable = focusableElements();

            if (!focusable.length) {
                event.preventDefault();
                panel.focus();
                return;
            }

            const first = focusable[0];
            const last = focusable[focusable.length - 1];

            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        });

        function handleBreakpointChange() {
            closeDrawer(false);
            restoreDesktopWidth();
            setPanelState();
            updateHeaderOffset();
        }

        if (typeof desktopQuery.addEventListener === 'function') {
            desktopQuery.addEventListener('change', handleBreakpointChange);
        } else {
            desktopQuery.addListener(handleBreakpointChange);
        }

        window.addEventListener('resize', function () {
            restoreDesktopWidth();
            updateHeaderOffset();
        });

        if (navigation) {
            const navigationObserver = new MutationObserver(function () {
                const siteMenuOpen = navigation.classList.contains('is-open');

                root.classList.toggle('is-site-menu-open', siteMenuOpen);

                if (siteMenuOpen) {
                    closeDrawer(false);
                }

                updateHeaderOffset();
            });

            navigationObserver.observe(navigation, {
                attributes: true,
                attributeFilter: ['class'],
            });
        }

        setPanelState();
        updateHeaderOffset();
        html.classList.add('dewa-libnav-ready');
    } catch (error) {
        document.documentElement.classList.remove('dewa-libnav-locked', 'dewa-libnav-ready', 'dewa-libnav-is-resizing');
    }
})();
